import * as types from './types';
import fetchData from '../../../shared/helpers/fetchData';
import fetchOptions from '../../../shared/helpers/fetchOptions';


export const receiveAddOnsResult = addOnsResult => ({
  type: types.RECEIVE_ADDONS_RESULT,
  addOns: addOnsResult.addOns,
});

export const fetchAddOns = function fetchAddOnsAction(url) {
  return function requestProductAddOns(dispatch) {
    return fetchData(
      url,
      fetchOptions('get'),
      {
        successHandler: receiveAddOnsResult,
        dispatch,
      },
    );
  };
};
